import { render, staticRenderFns } from "./postcode-search.vue?vue&type=template&id=6d868646&scoped=true"
import script from "./postcode-search.vue?vue&type=script&lang=js"
export * from "./postcode-search.vue?vue&type=script&lang=js"
import style0 from "./postcode-search.vue?vue&type=style&index=0&id=6d868646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d868646",
  null
  
)

export default component.exports